import "../theme/AdministracionCatalogo.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { authProvider } from "../context/authProvider";
import { TableAdministracionRegistroATB } from "../components/TableAdministracionRegistroATB";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const VistaATB = () => {
  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div>
              <div className="title-name-admin">
                <BtnGoBack caption="Volver a inicio" />
              </div>

              <TableAdministracionRegistroATB />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
